import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'gas-icon-core',
  templateUrl: './gas-icon-core.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GasIconCoreComponent { }
